import React, { useEffect, useState } from 'react';
import Numeral from 'numeral';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button, Drawer, Input, Field, Select } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

import { STRIPE_PRODUCTS } from '@brokerage/constants/Stripe';

const types = [
  { label: 'API Client', name: 'api_clients' },
  { label: 'ALQ', name: 'bga_quoters' },
  { label: 'Annuity Quoter', name: 'annuity_quoters' },
  { label: 'Form Engine', name: 'form_engines' },
  { label: 'LTC Quoter', name: 'ltc_quoters' },
  { label: 'Mobile App', name: 'mobile_apps' },
  { label: 'Website Quoter', name: 'website_quoters' },
  { label: 'Weebly Website', name: 'websites' },
  { label: 'Universal Quoter', name: 'universal_quoters' }
];

const NewProduct = ({ agency, onClose, show }) => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    type: 'api_clients',
    agency_id: agency.id,
    name: '',
    weebly_user_id: '',
    weebly_site_id: '',
    stripe_plan_id: ''
  });
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setData({
      type: 'api_clients',
      agency_id: agency.id,
      name: '',
      weebly_user_id: '',
      weebly_site_id: '',
      stripe_plan_id: ''
    });
  }, [show]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });

    if (name === 'type') {
      setErrors([]);
    }
  };

  const handleSave = () => {
    const { weebly_site_id, weebly_user_id, type, ...payload } = data;
    const errors = [];

    if (!payload.name) {
      errors.push('name');
    }
    if (type === 'websites' && !weebly_user_id) {
      errors.push('weebly_user_id');
    }
    if (type === 'websites' && !weebly_site_id) {
      errors.push('weebly_site_id');
    }

    setErrors(errors);

    if (!errors.length) {
      if (type === 'websites') {
        payload.weebly_site_id = weebly_site_id;
        payload.weebly_user_id = weebly_user_id;
      }

      window.scrollTo(0, 0);
      Api.createNewProduct(type, payload).then(({ data }) => {
        navigate(`/agencies/${agency.id}/products/${type}/${data.id}`);
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Create Product</Button>}
      onClose={onClose}
      show={show}
      title='New Product'
    >
      <Field label='Type'>
        <Select
          onChange={handleInputChange.bind(null, 'type')}
          options={types.map(type => {
            return {
              value: type.name,
              label: type.label
            };
          })}
          value={data.type}
        />
      </Field>

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          value={data.name}
        />
      </Field>

      {data.type === 'websites' ? (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Field label='Weebly User ID'>
            <Input
              invalid={errors.includes('weebly_user_id')}
              onChange={handleInputChange.bind(null, 'weebly_user_id')}
              required={true}
              style={{ width: '49%' }}
              value={data.weebly_user_id}
            />
          </Field>
          <Field label='Weebly Site ID'>
            <Input
              invalid={errors.includes('weebly_site_id')}
              onChange={handleInputChange.bind(null, 'weebly_site_id')}
              required={true}
              style={{ width: '49%' }}
              value={data.weebly_site_id}
            />
          </Field>
        </div>
      ) : null}

      {!agency.is_demo && !agency?.agency_type ? (
        <Field label='Plan'>
          <Select
            onChange={handleInputChange.bind(null, 'stripe_plan_id')}
            options={STRIPE_PRODUCTS.filter(p => p.category === data.type).map(product => ({
              value: product.plan,
              label: `${product.frequency} - ${product.name} - ${Numeral(product.price).format(
                '$0,00'
              )}`
            }))}
            placeholder='-- Select Plan --'
            value={data.stripe_plan_id}
          />
        </Field>
      ) : null}
    </Drawer>
  );
};

NewProduct.propTypes = {
  agency: PropTypes.object,
  onClose: PropTypes.func,
  show: PropTypes.bool
};

export default NewProduct;
